<template>
	<div>
		<ul class="v-expansion-panel theme--light">
			<li
				class="v-expansion-panel__container accordion-card-wrapper v-expansion-panel__container--active"
			>
				<div class="v-expansion-panel__header">
					<slot name="icon"></slot>
					<div class="accordion-card-header">
						{{ accordion_header }}
					</div>
					<slot name="select"></slot>
				</div>
				<v-icon
					class="fullscreen-icon"
					v-if="expand_accondion"
					@click="openModal"
					>fullscreen</v-icon
				>
				<div class="v-expansion-panel__body">
					<v-sheet ref="slotMapWrapper">
						<slot name="component"></slot>
					</v-sheet>
				</div>
			</li>
		</ul>
		<!-- <v-expansion-panel v-model="panel" :expand="expanded" :disabled="expand_accondion || !toggable">
		<v-expansion-panel-content class="accordion-card-wrapper">
			<template v-slot:header>
				<slot name="icon"></slot>
				<div class="accordion-card-header">{{accordion_header}}</div>
			</template>
			<v-icon class="fullscreen-icon" v-if="expand_accondion" @click="openModal">fullscreen</v-icon>
			<v-sheet ref="slotMapWrapper">
				<slot name="component"></slot>
			</v-sheet>
		</v-expansion-panel-content>
	</v-expansion-panel> -->
		<v-dialog
			v-if="expand_accondion"
			v-model="showdialog"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-toolbar dark color="primary">
					<v-toolbar-title>{{ accordion_header }}</v-toolbar-title>
					<v-btn icon dark @click="closeModal">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<template v-if="showdialog">
					<slot name="component"></slot>
				</template>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: "BaseAccordionController",
	props: {
		accordion_header: {
			type: [String],
			required: false,
		},
		expand_accondion: {
			type: [Boolean],
			required: false,
			default: false,
		},
		expanded: {
			type: [Boolean],
			default: true,
			required: false,
		},
		toggable: {
			type: [Boolean],
			default: true,
			required: false,
		},
	},
	data() {
		return {
			panel: [true],
			dialog: false,
			showdialog: false,
		};
	},
	methods: {
		closeModal() {
			this.showdialog = false;
		},
		openModal() {
			this.showdialog = true;
		},
	},
};
</script>

<style lang="scss">
.accordion-card-wrapper {
	position: relative;
	background-color: white;
	box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
	border-radius: 10px;
	margin: 8px;
	border: none !important;
	overflow: hidden;
	.accordion-card-header {
		font-size: 15px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.fullscreen-icon {
		position: absolute;
		top: 14px;
		right: 14px;
	}
}

.v-expansion-panel {
	box-shadow: none !important;
}

.v-expansion-panel__header {
	min-height: auto !important;
	padding: 15px !important;
}

.v-input--selection-controls {
	margin-bottom: 0px !important;
}

.v-expansion-panel__container--disabled {
	color: rgba(0, 0, 0, 0.87) !important;
}
</style>
